import { render, staticRenderFns } from "./Workers.vue?vue&type=template&id=70463b30"
import script from "./Workers.vue?vue&type=script&lang=js"
export * from "./Workers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports